import { translate } from '../../../i18n/I18nProvider';
import capitaliseFirstLetter from '../../../utils/capitaliseFirstLetter';

const createUSubscriptionColumnsLabels = () => {
  let columns = [
    { label: translate('TABLE.NAME'), key: 'name' },
    {
      label: translate('ACCOUNT'),
      key: 'accountName'
    },
    {
      label: 'Product Category',
      key: 'commercialProduct'
    },
    {
      label: capitaliseFirstLetter(translate('SUBSCRIPTIONS.GROUP_BY_SKU')),
      key: 'skuTranslation'
    },
    {
      label: translate('STATUS'),
      key: 'status'
    },
    {
      label: translate('ACTIVATION_DATE'),
      key: 'activationDate'
    },
    {
      label: translate('EXPIRE_DATE'),
      key: 'expiryDate'
    },
    {
      label: translate('QUANTITY'),
      key: 'quantity'
    },
    {
      label: translate('EDIT.USER'),
      key: 'user'
    }
  ];

  return columns;
};

export default createUSubscriptionColumnsLabels;
